import styled from 'styled-components';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { borderRadius, colors, duration, easing } from 'ui/theme';

export const ScrollAreaViewport = styled(ScrollAreaPrimitive.Viewport)`
  width: 100%;
  height: 100%;
  border-radius: inherit;
`;

export const ScrollAreaScrollbar = styled(ScrollAreaPrimitive.Scrollbar)`
  display: flex;
  user-select: none;
  touch-action: none;
  padding: 2px;
  background: transparent;
  transition: background ${duration.short} ${easing.entrance};

  &[data-orientation="vertical"] {
    width: 10px;
  }

  &[data-orientation="horizontal"] {
    flex-direction: column;
    height: 10px;
  }

  &:hover {
    background: ${colors.backgroundEmphasis};
  }
`;

export const ScrollAreaThumb = styled(ScrollAreaPrimitive.Thumb)`
  flex: 1;
  background: ${colors.borderEmphasis};
  border-radius: ${borderRadius.md};
  position: relative;

  &:hover {
    background: ${colors.borderStrong};
  }

  &:active {
    background: ${colors.borderEmphasis};
  }
`;

export const ScrollAreaCorner = styled(ScrollAreaPrimitive.Corner)`
  background: ${colors.backgroundSecondary};
`;

export const ScrollAreaRoot = styled(ScrollAreaPrimitive.Root)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
  position: relative;
`;

export const ScrollMask = styled.div<{
  position: 'top' | 'bottom' | 'left' | 'right';
  size?: string;
}>`
  position: absolute;
  z-index: 1;
  pointer-events: none;

  ${({ position, size = '40px' }) => {
    const gradientDirection = {
      top: 'to bottom',
      bottom: 'to top',
      left: 'to right',
      right: 'to left',
    }[position];

    const positionStyles = {
      top: { top: 0, left: 0, right: 0, height: size },
      bottom: { bottom: 0, left: 0, right: 0, height: size },
      left: { left: 0, top: 0, bottom: 0, width: size },
      right: { right: 0, top: 0, bottom: 0, width: size },
    }[position];

    return {
      background: `linear-gradient(${gradientDirection}, 
                   ${colors.backgroundSecondary} 0%, 
                   rgba(250, 250, 250, 0) 100%)`,
      ...positionStyles,
    };
  }}
`;
